<template>
  <fragment>
    <app-header title="Media Owner Screen Tags"></app-header>

    <div class="container">
    <validation-observer tag="div" class="row" @submit.native.prevent ref="validation">
      <validation-provider tag="div" class="col" name="name" rules="required">
        <label>Add Media Owner Screen Tag</label>
        <c-input type="text" v-model="stateName" />
        <c-help-block/>
      </validation-provider>
      <div class="col-auto">
        <c-button
          validate
          variant="primary"
          @click="save"
          class="mt-label"
        >
          Add
        </c-button>
      </div>
    </validation-observer>
      <ul id="horizontal-nav" class="nav nav-horizontal">
        <li class="nav-item" :class="{ active: !archived }"><a class="nav-link" href="#" @click="archived = false">Published</a></li>
        <li class="nav-item" :class="{ active: archived }"><a class="nav-link" href="#" @click="archived = true">Archived</a></li>
      </ul><!-- /#horizontal-nav -->

      <ul class="list-data no-links mt-0">
        <div class="col-auto">
            <c-data-list :items="filteredList">
              <template #columns>
                <div class="col-xl-4">Tag</div>
                <div class="col-xl-4">Media Owner</div>
                <div class="col-xl-2"></div>
              </template>
              <template #default="{ item }">
                <media-owner-screen-tag-list-item :item="item"/>
              </template>
            </c-data-list>
        </div>
      </ul><!-- /.list-data -->
    </div>
  </fragment>
</template>
<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/settings/media-owner-screen-tags'
import { toast } from '@chameleon/chameleon-vue'
import MediaOwnerScreenTagListItem from '@/views/settings/MediaOwnerScreenTagListItem.vue'

export default {
  mixins: [
    stateMapper
  ],

  components: {
    MediaOwnerScreenTagListItem,
  },

  created () {
    this.getMediaOwnerScreenTags()
  },

  computed: {
    ...helperComputed,
    filteredList () {
      return this.mediaOwnerScreenTags.filter(({ archived }) => archived === this.archived)
    }
  },

  data () {
    return {
      archived: false
    }
  },

  methods: {
    ...helperMethods,

    async save () {
      try {
        await this.storeMediaOwnerScreenTag(this.mediaOwnerScreenTag)
        this.resetMediaOwnerScreenTag()
      } catch (error) {
        if (error.response && error.response.status >= 400) {
          toast(error.response.data.message ?? 'Something went wrong creating a media owner tag.', 'danger')
          return
        }
      }
      this.$refs.validation.reset()
    },

    async handleArchive (item) {
      if (item.archived) {
        await this.updateMediaOwnerScreenTag(item)
        this.resetMediaOwnerScreenTag()
        this.getMediaOwnerScreenTags({ fresh: true })
      } else {
        await this.deleteMediaOwnerScreenTag(item.id)
        await this.getMediaOwnerScreenTags({ fresh: true })
      }
    }
  }
}
</script>
